import React, { useState } from "react";
import { useSelector } from "react-redux";
import ChannelMessagesAndInput from "../Components/Communication/ChannelMessagesAndInput";
import CommunicationSidebar from "../Components/Communication/CommunicationSidebar";
import ShowMessageWhenUnSelect from "../Components/Communication/ShowMessageWhenUnSelect";
import UserMessagesAndInput from "../Components/Communication/UserMessagesAndInput";
import ButtonGroupPortfolio from "../Components/Profile/ButtonGroup";

const tabs = [
  { id: 1, Icon: null, name: "Private Message" },
  { id: 2, Icon: null, name: "Channel Message" },
];

const Communication = () => {
  const [menuState, setMenuState] = useState([]);
  // const [connectedUser, setConnectedUser] = useState([]);
  console.log("menuState:", menuState);
  const selectedUserOrChannel =
    useSelector((state) => state.user.selectedUserOrChannel) || {};
  const [selectedtab, setSelectedTab] = useState(tabs[0].id);
  const [isLoading, setIsLoading] = useState(false);
  const ShowMessageDataComponent = {
    user: <UserMessagesAndInput />,
    channel: <ChannelMessagesAndInput />,
    null: <ShowMessageWhenUnSelect />,
  };

  const showData = String(selectedUserOrChannel?.type ?? null);

  return (
    <>
      <ButtonGroupPortfolio
        tabs={tabs}
        selectedtab={selectedtab}
        setSelectedTab={setSelectedTab}
      />
      <div className="flex gap-3 h-full w-full bg-pureWhite p-2 rounded-3xl">
        <CommunicationSidebar
          isLoading={isLoading}
          selectedtab={selectedtab}
          menuState={menuState}
          setMenuState={setMenuState}
        />
        <div className="w-[70%]">{ShowMessageDataComponent[showData]}</div>
      </div>
    </>
  );
};

export default Communication;
